import React from 'react';

export function LocationIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12.6}
      height={12.6}
      className="antv-s2-icon"
      viewBox="0 0 1024 1024"
      {...props}
    >
      <path
        fill="currentColor"
        d="M511.804 222.338q-85.675 0-145.86 60.184-60.183 60.185-60.184 145.337 0 85.153 60.185 145.337 60.183 60.185 145.859 60.185 85.674 0 145.859-60.185 60.184-60.184 60.184-145.337t-60.184-145.337-145.86-60.184zm0 338.619q-55.093 0-93.835-38.774t-38.773-93.834q-.033-55.061 38.773-94.357 38.808-39.296 93.835-39.263 55.028.033 93.834 39.263t38.774 94.357q-.033 55.125-38.774 93.834t-93.834 38.774m366.165-295.766q-31.626-63.252-87.73-111.165-56.106-47.912-127.484-75.491Q590.331 52 511.804 52q-78.528 0-151.963 26.535-70.367 27.546-126.472 75.491t-87.731 111.165Q113 330.468 113 400.835q0 98.926 47.945 200.92 39.787 84.662 111.165 167.27 93.834 110.152 216.227 195.827Q498.553 972 511.282 972q12.727 0 23.956-7.148 122.392-86.686 216.227-195.828 71.412-83.65 111.165-167.27 47.945-101.993 47.945-200.919 0-70.367-32.638-135.644zm-40.797 136.656q0 82.606-40.798 169.326-34.693 74.447-99.97 150.95-78.527 91.812-184.6 169.326-106.075-77.514-184.6-169.326-64.265-76.503-99.971-150.95-40.797-86.686-40.797-170.338 0-54.048 24.478-104.05 25.491-48.957 70.368-87.73 45.889-39.786 104.05-62.209 61.195-22.455 126.472-22.455t126.472 22.455q58.129 22.455 104.05 62.208 45.889 38.775 70.367 87.731 24.48 51.014 24.479 105.062"
      />
    </svg>
  );
}
